import * as React from 'react';
import { useMutation } from '@apollo/client';

import Icon from '../../../../components/ui/Icon';
import { MaintenanceButton } from '../../../../components/ui/MaintenanceButton';
import { notification } from '../../../../utils/notification';
import {
    ONBOARDING_GETINDEXABLEFILESFORPLANT_QUERY,
    ONBOARDING_SYNCDOCUMENTS_MUTATION,
} from './../../../../api/GraphQLQueries/Onboarding';

interface IProps {
    plantS3Folder: string;
    disabled?: boolean;
}

const DocumentsSyncMutation: React.FC<IProps> = ({ plantS3Folder, disabled }) => {
    const [doDocumentSyncMutation, { loading }] = useMutation(ONBOARDING_SYNCDOCUMENTS_MUTATION, {
        variables: { plantS3Folder },
        onCompleted: () => {
            notification.success('Successfully started document sync');
        },
        onError: () => {
            notification.error('Document sync error');
        },
        refetchQueries: [
            {
                query: ONBOARDING_GETINDEXABLEFILESFORPLANT_QUERY,
                variables: { plantS3Folder },
            },
        ],
    });

    return (
        <MaintenanceButton
            type="button"
            color={undefined}
            disabled={disabled}
            onClick={() => {
                if (!loading && !disabled) {
                    doDocumentSyncMutation();
                }
            }}
        >
            {loading && <Icon icon="fa-cog fa-spin" />}
            <span>
                {loading
                    ? 'Started S3 sync, please wait'
                    : 'Sync S3 Documents to Spindex'}
            </span>
        </MaintenanceButton>
    );
};

export default DocumentsSyncMutation;
